export default __webpack_public_path__ + "static/media/m-icon-gnb-btn-cart.50fe4eac.svg";